import { render } from "./axoSidebar.vue?vue&type=template&id=042a7f76"
import script from "./axoSidebar.vue?vue&type=script&lang=js"
export * from "./axoSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__